<template>

<div>
    <label>{{ label }}</label>
    <div class="flex spacebetween">
      <div>
        <span class="datelabel">{{ trans.global.from[lang] }}</span>
        <div class="flex">
          <!-- <div>
            <label class="small">{{ trans.application.tag[lang] }}</label>
            <select v-model="day1" @change="validate">
              <option>{{ trans.global.please_choose[lang] }}</option>
              <option v-for="day in dayarray" :value="day" :key="day">{{ day }}</option>
            </select>
          </div> -->
          <div>
            <label class="small">{{ trans.application.monat[lang] }}</label>
            <select v-model="month1" @change="validate">
              <option>{{ trans.global.please_choose[lang] }}</option>
              <option v-for="month in montharray" :value="month" :key="month">{{ month }}</option>
            </select>
          </div>
          <div>
              <label class="small">{{ trans.application.jahr[lang] }}</label>
              <select v-model="year1" @change="validate">
                <option>{{ trans.application.jahr[lang] }}</option>
                <option v-if="mode=='age'" v-for="year in yearsAgeArray" :value="year" :key="year">{{ year }}</option>
                <option v-if="mode=='next'" v-for="year in yearsNextArray" :value="year" :key="year">{{ year }}</option>
                <option v-if="mode=='last'" v-for="year in yearsLastArray" :value="year" :key="year">{{ year }}</option>
              </select>
          </div>
        </div>
      </div>
       <div>
        <span class="datelabel">{{ trans.global.until[lang] }}</span>
        <div class="flex">
          <!-- <div>
            <label class="small">{{ trans.application.tag[lang] }}</label>
            <select v-model="day2" @change="validate">
              <option>{{ trans.global.please_choose[lang] }}</option>
              <option v-for="day in dayarray" :value="day" :key="day">{{ day }}</option>
            </select>
          </div> -->
          <div>
            <label class="small">{{ trans.application.monat[lang] }}</label>
            <select v-model="month2" @change="validate">
              <option>{{ trans.global.please_choose[lang] }}</option>
              <option v-for="month in montharray" :value="month" :key="month">{{ month }}</option>
            </select>
          </div>
          <div>
              <label class="small">{{ trans.application.jahr[lang] }}</label>
              <select v-model="year2" @change="validate">
              <option>{{ trans.global.please_choose[lang] }}</option>
                <option v-if="mode=='age'" v-for="year in yearsAgeArray" :value="year" :key="year">{{ year }}</option>
                <option v-if="mode=='next'" v-for="year in yearsNextArray" :value="year" :key="year">{{ year }}</option>
                <option v-if="mode=='last'" v-for="year in yearsLastArray" :value="year" :key="year">{{ year }}</option>
              </select>
          </div>
        </div>
      </div>

    </div>

</div>

</template>

<script>

export default {
    data: function() {
            return  {
                day1:'',
                month1:'',
                year1:'',
                day2:'',
                month2:'',
                year2:'',
            }
    },
  props: ["value","label","mode","titlebefore","remarks","trans","lang"],
  computed:{
    dayarray() {
      const days = []
      for(let i = 1; i <= 31; i++){
        days.push(i)
      }
      return days
    },
   montharray() {
      const months = []
      for(let i = 1; i <= 12; i++){
        months.push(i)
      }
      return months
    },
    yearsAgeArray() {
      const years = []
        var endYear = new Date().getFullYear();
        var startYear = endYear - 16;
        while ( startYear <= endYear ) {
            years.push(startYear++);
        }
        return years;
    },
     yearsNextArray() {
      const years = []
        var endYear = new Date().getFullYear() + 4;
        var startYear = new Date().getFullYear();;
        while ( endYear >= startYear ) {
            years.push(startYear++);
        }
        return years;
    },
     yearsLastArray() {
      const years = []
        var endYear = new Date().getFullYear() - 15;
        var startYear = new Date().getFullYear();;
        while ( endYear <= startYear ) {
            years.push(startYear--);
        }
        return years;
    }
  },
  model: {
    prop: "value",
    event: "update"
  },
  mounted() {
        this.loadSessionData();
    },
  methods: {
      validate(){
        var date = '';

        if(this.year1 > 0 && this.month1 > 0  && this.year2 > 0 && this.month2 > 0 )
        {
          var d = new Date(this.year1, this.month1 - 1, this.day1, 0, 0, 0, 0);
          var dd = String(d.getDate()).padStart(2, '0');
          var mm = String(d.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy = d.getFullYear();
          var date1 = dd + '.' + mm + '.' + yyyy;

          var d = new Date(this.year2, this.month2 - 1, this.day2, 0, 0, 0, 0);
          var dd = String(d.getDate()).padStart(2, '0');
          var mm = String(d.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy = d.getFullYear();
          var date2 = dd + '.' + mm + '.' + yyyy;

          this.$emit('update', date1 + "-" + date2);
        }
        else
        {
          this.$emit('update', '');
        }
      },
      loadSessionData(){
        let app = this;

        const dates = app.value.split("-");
        if(app.day1 == '' && app.month1 == '' && app.year1 == '' &&  app.value)
        {
              var dd =  dates[0].split(".");
              app.day1 = parseInt(dd[0]);
              app.month1 = parseInt(dd[1]);
              app.year1 = parseInt(dd[2]);
        }
        if(app.day2 == '' && app.month2 == '' && app.year2 == '' &&  app.value)
        {
              var dd =  dates[1].split(".");
              app.day2 = parseInt(dd[0]);
              app.month2 = parseInt(dd[1]);
              app.year2 = parseInt(dd[2]);
        }
    }
  }
};
</script>
